import { AdministrationBotSelect } from "./AdministrationBotSelect";
import { SecurityChatSelect } from "./SecurityChatSelect";
import { SecurityHeader } from "./SecurityHeader";
import { NormalizedStorageObject } from "../../../../../../services/api/instances/storageApi/types/object_types";
import { ChatbotValue } from "../../../../../../services/api/instances/botApi/types";
import { TValueForService } from "../../../../../../services/api/instances/storageApi/types/service_types";
import { useAppSelector } from "../../../../../../services/redux/hooks/use-selector";
import { selectUserInfo } from "../../../../../Auth/redux/selectors";
import { useMemo } from "react";

interface Props {
  bots: NormalizedStorageObject<ChatbotValue>[];
  bot: NormalizedStorageObject<ChatbotValue>;
  saveChatbotValue: (
    value: TValueForService<"ai_agents_telegram_bots">,
  ) => void;
}

export const ChatbotSecurity = (props: Props) => {
  const userInfo = useAppSelector(selectUserInfo);

  const botRef = useMemo(() => {
    const botSecureName = props.bot?.value?.tg_bot_object?.secure_bot_name;
    const secureBot = props.bots.find(
      (b) => b.value?.tg_bot_object?.bot_name === botSecureName,
    );
    return secureBot && secureBot?.value
      ? secureBot.value.tg_bot_object?.ref
      : null;
  }, [props.bot?.id, props.bot?.value?.tg_bot_object?.secure_bot_name]);

  return (
    <>
      {userInfo?.hide_security_bar ? (
        <></>
      ) : (
        <>
          <SecurityHeader
            bot={props.bot}
            saveChatbotValue={props.saveChatbotValue}
          />
          <AdministrationBotSelect
            bots={props.bots}
            bot={props.bot}
            saveChatbotValue={props.saveChatbotValue}
          />
          <SecurityChatSelect
            bot={props.bot}
            saveChatbotValue={props.saveChatbotValue}
            botRef={botRef}
          />
        </>
      )}
    </>
  );
};
